import {
  ButtonGroup,
  DateInputField,
  Grid,
  GridItem,
  PrimaryButton,
} from "@certn/cascadia-react";
import { formatDate } from "@certn/utils";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useFormSubmit } from "../../../hooks/api/useSubmit";
import { useUser } from "../../../hooks/api/useUser";

export function BirthdaySettings() {
  const { t } = useTranslation();
  const { user, mutate } = useUser();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);

  const handleSubmit = useFormSubmit("/internal/people/me/birthday/update/", {
    onSuccess: () => {
      toggle();
      mutate();
    },
  });

  return (
    <SettingsEditItem
      setting={t("Birthday")}
      value={formatDate(user?.personal_profile?.date_of_birth, "PPP")}
      description={t(
        "We recommend using the information on a government issued identity document or birth certificate as this may be used to auto-populate forms."
      )}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "birthday-cancel-link" : "birthday-edit-link"}
    >
      <Formik
        initialValues={{
          date_of_birth: user?.personal_profile?.date_of_birth || "",
        }}
        onSubmit={handleSubmit}
        validationSchema={object({
          date_of_birth: string().required(
            t("The date of birth field is required")
          ),
        })}
      >
        {() => {
          return (
            <Form>
              <Grid width="416px">
                <GridItem>
                  <Field
                    name="date_of_birth"
                    label={t("Date of birth")}
                    as={DateInputField}
                    isRequired
                  />
                </GridItem>
                <GridItem>
                  <ButtonGroup>
                    <PrimaryButton
                      type="submit"
                      size="medium"
                      testID="birthday-save-button"
                    >
                      {t("Save")}
                    </PrimaryButton>
                  </ButtonGroup>
                </GridItem>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </SettingsEditItem>
  );
}
